import { useState, useCallback } from 'react';

import { ProveVerificationModal } from './ProveVerificationModal';

export type ConnectedProveVerificationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  phone: string;
  isAwaitingInstantLink: boolean;
  onSubmitCode: (code: string) => void;
  onTryAgain: () => void;
};

export default function ConnectedProveVerificationModal({
  isOpen,
  onClose,
  phone,
  isAwaitingInstantLink,
  onSubmitCode,
  onTryAgain,
}: ConnectedProveVerificationModalProps) {
  const [code, setCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleVerifyCode = useCallback(() => {
    if (code.trim()) {
      setIsLoading(true);
      onSubmitCode(code.trim());
    }
  }, [code, onSubmitCode]);

  const handleTryAgain = useCallback(() => {
    setCode('');
    setIsLoading(false);
    onTryAgain();
  }, [onTryAgain]);

  return (
    <ProveVerificationModal
      isOpen={isOpen}
      onClose={onClose}
      phone={phone}
      code={code}
      onCodeChange={setCode}
      onVerifyCode={handleVerifyCode}
      onTryAgain={handleTryAgain}
      isAwaitingInstantLink={isAwaitingInstantLink}
      isLoading={isLoading}
    />
  );
}
